import { i18nFilter } from "app/filters/i18nFilter";
import type { ReactNode } from "react";
import type React from "react";
import { openContactUsModal } from "app/services/ModalService";

interface IContactUsLinkProps {
    label: string; // Name of parent component (e.g. "Trial Banner")
    className?: string;
    text?: string;
    onClick?: (e?: React.MouseEvent<HTMLAnchorElement>) => void;
    children?: ReactNode;
}

const ContactUsLink: React.FunctionComponent<IContactUsLinkProps> = (props) => {
    const { children, className, label, text, onClick } = props;

    return (
        <a
            className={className}
            onClick={(e) => {
                openContactUsModal(label);
                onClick?.(e);
            }}
        >
            {text ? i18nFilter()(text) : children}
        </a>
    );
};

export default ContactUsLink;
